import $ from "jquery";
import { replaceWithContent } from "../utils/replaceWithContent.js";
import { request } from "../utils/request.js";
const LOADING_HTML = '<div style="height:50px;text-align:center;"><div class="spinner is-active" style="float: initial;margin: 0;"></div></div>';
async function renderShortcutInfoContainer(container) {
    const { id } = container.dataset;
    if (!id || container.childElementCount > 0) {
        return;
    }
    container.innerHTML = LOADING_HTML;
    try {
        const { html } = await request({
            location: {
                path: `/attachments/${id}/shortcutInfo`
            }
        });
        replaceWithContent($(container), html);
    } catch  {
        container.replaceChildren();
    }
}
export { renderShortcutInfoContainer };
